import { FormattedMessage } from "react-intl";
import React from "react/lib/React";

export const fieldCounter = (currentCount) => {
    return (
        <span className="text-counter">
            <FormattedMessage id="characterCount" values={{ currentCount: currentCount.toString() }} />
        </span>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/form/FieldCounter.js